import makeCategories from '@main/factories/pages/makeCategories';
import { useData } from 'vike-react/useData';

import type { Data } from './+data';

export function Page() {
	const { firstPage } = useData<Data>();

	return makeCategories(firstPage);
}
